/**
 * Get Dashboard Metrics Use Case
 * Obtém métricas detalhadas do dashboard
 */
import { DashboardRepository } from '../repositories/dashboard_repository';
import { DashboardMetricsEntity } from '../entities/dashboard_entity';

export class GetDashboardMetricsUseCase {
  constructor(private repository: DashboardRepository) {}

  async execute(period?: 'day' | 'week' | 'month' | 'year'): Promise<DashboardMetricsEntity> {
    console.log('📈 UseCase: Executando obtenção de métricas...', { period });
    
    try {
      const metrics = await this.repository.getMetrics(period);
      console.log('✅ UseCase: Métricas obtidas com sucesso', metrics);
      return metrics;
    } catch (error) {
      console.error('❌ UseCase: Erro ao obter métricas', error);
      throw error;
    }
  }

  async executeDaily(): Promise<DashboardMetricsEntity> {
    return this.execute('day');
  }

  async executeWeekly(): Promise<DashboardMetricsEntity> {
    return this.execute('week');
  }

  async executeMonthly(): Promise<DashboardMetricsEntity> {
    return this.execute('month');
  }

  async executeYearly(): Promise<DashboardMetricsEntity> {
    return this.execute('year');
  }
}
